<template>
  <b-modal
    ref="modal-rrhh-employee-viatic-tracking"
    v-model="showModal"
    :title="$t('VIATIC TRACKING')"
    modal-class="modal-primary"
    hide-footer
    @hidden="$emit('hideModal')"
    size="lg"
    scrollable
  >
    <div class="mb-2 mt-1">
      <b-row>
        <b-col sm="6">
          <b-input-group class="mb-1">
            <template #prepend>
              <b-input-group-text class="prepend__width">
                <strong>{{ $t("CODE") }}</strong>
              </b-input-group-text>
            </template>
            <b-form-input :value="payroll.personal_code" disabled />
          </b-input-group>
        </b-col>
        <b-col sm="6">
          <b-input-group class="mb-1">
            <template #prepend>
              <b-input-group-text class="prepend__width">
                <strong>{{ $t("Employee") }}</strong>
              </b-input-group-text>
            </template>
            <b-form-input :value="payroll.full_name" disabled />
          </b-input-group>
        </b-col>
      </b-row>
    </div>
    <div class="table-responsive">
      <b-table
        small
        sticky-header="50vh"
        class="position-relative"
        table-class="text-nowrap"
        :items="items"
        :fields="fields_filtered"
      >
        <template #cell(created_by)="data">
          <span> {{ data.value | capitalize }} </span> <br />
        </template>
        <template #cell(status)="data">
          <b-badge pill :variant="getPayrollStatusVariant(data.value)">
            <span> {{ $t(data.value) }}</span>
          </b-badge>
        </template>
        <template #cell(observation)="data">
          <span style="opacity: 0.5">
            <span> {{ $t(data.value) }}</span>
          </span>
        </template>
        <template #cell(created_at)="data">
          <span style="opacity: 0.5">
            {{ data.item.created_at | globalDate }}
          </span>
        </template>
      </b-table>
    </div>
  </b-modal>
</template>

<script>
import FieldsModal from "@/views/rrhh/views/payroll/components/operations-payroll/payroll-tracking/data/fields.payroll.tracking.js";
import PayrollService from "@/views/rrhh/views/payroll/services/payroll.service.js";

export default {
  props: {
    payroll: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      items: [],
      fields: FieldsModal,
      showModal: true,
    };
  },
  async created() {
    await this.getPayrollTracking();
  },
  computed: {
    fields_filtered() {
      this.fields.map((row) => (row.label = this.$t(row.label)));
      return this.fields.filter((row) => row.visible);
    },
  },
  methods: {
    async getPayrollTracking() {
      try {
        this.addPreloader();
        const params = {
          payroll_id: this.payroll.id,
        };
        const { data } = await PayrollService.getPayrollTracking(params);
        this.items = data;
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },

    getPayrollStatusVariant(status) {
      const variant = {
        "Fortnight Generated": "light-primary",
        "Fortnight Pending": "light-warning",
        "Fortnight Paid": "light-success",
        "Generated Salary": "light-primary",
        Approved: "light-success",
        Paid: "light-success",
        default: "light-info",
      };

      return variant[status] || variant.default;
    },
  },
};
</script>